$(document).ready(function() {
  
    $('.secondary-images').slick({
        dots: false,
        infinite: false,
        vertical: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });
  
  
    //toggle the component with class accordion_body
    $(".accordion_head").click(function() {
        if ($('.accordion_body').is(':visible')) {
            $(".accordion_body").slideUp(300);
            $(".plusminus").text('+');
        }
        if ($(this).next(".accordion_body").is(':visible')) {
            $(this).next(".accordion_body").slideUp(300);
            $(this).children(".plusminus").text('+');
        } else {
            $(this).next(".accordion_body").slideDown(300);
            $(this).children(".plusminus").text('-');
        }
    });

    $('.product-single__description .accordion_body ').css('display', 'block');
    
  //if(window.location.href.indexOf('/products/') > 0){  

    // Scirpt to show Deatils Page "you save %" and "Per Pack" //
  if($('.single-option-radio').length > 1){
    
    
    $('.single-option-radio').change(function(){
    var radioButtons = $('#ProductSelect-option-1 .single-option-selector__radio');
	var selectedIndex = radioButtons.index(radioButtons.filter(':checked'));    
    if(selectedIndex > 0){
 		var onepack = $('[name="' + $('#ProductSelect-option-0 input:checked').val() + ' / ' + $('#ProductSelect-option-1 input').eq(0).val() + '"]').text();
     	var thisPacks = $('#ProductSelect-option-1 input:checked').val().split('-')[0];      
      	var priceNew =  $('[name="' + $('#ProductSelect-option-0 input:checked').val() + ' / ' + $('#ProductSelect-option-1 input:checked').val()  + '"]').text();
     	var actualThisPackVal = onepack * thisPacks;
        var PercentSaveVal = Math.round((actualThisPackVal - priceNew) / actualThisPackVal * 100);
        $('.yousavepercent').html('<span>- You Save</span> ' + PercentSaveVal + "%");
      } else{
      	$('.yousavepercent').html('');      
      };
      if($('#AddToCart--product-template').attr('disabled') == 'disabled'){
      $('.d_instock').text('Sold Out');
      } else {
      $('.d_instock').text('In Stock');
      }   
      
    })
    
    // "Per Pack " for Multivarient Listing
      $("label[for*='ProductSelect-option-pack-size']").each(function() {
      var packSize = $(this).text().split('-Pack')[0];
      var priceNew =  $('[name="' + $('#ProductSelect-option-0 input:checked').val() + ' / ' + $(this).text()  + '"]').text();
          if (packSize > 1) {
              $(this).text(packSize + "-Pack - $" + priceNew +" ($" + (priceNew / packSize).toFixed(2) + ' per filter)')
          }        
      });    
    // "you save %" for Multivarient Listing
    $('#ProductSelect-option-0 .single-option-selector__radio').click(function(){
      var $thisval = $(this).val();
    	$("label[for*='ProductSelect-option-pack-size']").each(function() {
      var packSize = $(this).text().split('-Pack')[0];
      var priceNew =  $('[name="' + $thisval + ' / ' + packSize + '-Pack"]').text();
          if (packSize > 1) {
              $(this).text(packSize + "-Pack - $" + Number(priceNew).toFixed(2) +" ($" + (priceNew / packSize).toFixed(2) + ' per filter)')
          }        
      });
    });
    
    if( $('#AddToCart--product-template').attr('disabled') == 'disabled' && $('#buyonamazon').text().length > 0 ){
          $('#AddToCart--product-template, .d_soldout').hide();
          $('#buyonamazon, .soldout_but_aoa').show();
        }
    
    
  
  } else if($('.single-option-radio').length == 1){
    
  // "you save %" for Multipack Single Listing
    var currentPrice = $('.single-option-selector__radio').eq(0).val().split('- $')[1];
    var onepack = currentPrice / $('.single-option-selector__radio').eq(0).val().split('-')[0];
  	var selectedPacks = $('.single-option-selector__radio[checked="checked"]').val().split('-')[0];
    var actualPackVal = onepack * selectedPacks;
  
  	var radioButtons = $('.single-option-selector__radio');
	var selectedIndex = radioButtons.index(radioButtons.filter(':checked'));
  
    if(selectedIndex > 0){
    	var currentPrice = $('.single-option-selector__radio[checked="checked"]').val().split('- $')[1];
        var PercentSaveVal = Math.round((actualPackVal - currentPrice) / actualPackVal * 100);
        $('.yousavepercent').html('<span>- You Save</span> ' + PercentSaveVal + "%");
    }
    $('.single-option-selector__radio').change(function() {
      var radioButtons = $('.single-option-selector__radio');
		var selectedIndex = radioButtons.index(radioButtons.filter(':checked'));
      if(selectedIndex > 0){
  		var thisPacks = $(this).val().split('-')[0];
    	var actualThisPackVal = onepack * thisPacks;
        var priceNew = $(this).val().split('- $')[1];
        var PercentSaveVal = Math.round((actualThisPackVal - priceNew) / actualThisPackVal * 100);
        $('.yousavepercent').html('<span>- You Save</span> ' + PercentSaveVal + "%");
      } else{
      	$('.yousavepercent').html('');
      };
      
    });
    
    $("label[for*='ProductSelect-option-pack-size']").each(function() {
        var packSize = $(this).text().split('-')[0];
        if (packSize > 1) {
            $(this).append(" ($" + ($(this).attr('for').split('- $')[1] / packSize).toFixed(2) + ' per filter)')
        }
    });
  
      if( $('#AddToCart--product-template').attr('disabled') == 'disabled' && $('#buyonamazon').text().length > 0 ){
          $('#AddToCart--product-template, .d_soldout').hide();
          $('#buyonamazon, .soldout_but_aoa').show();
        }
  
  }
  

//}
  
    $('#RecoverPassword').click(function(e) {
        e.preventDeafault();
        $('#CustomerLoginForm').hide();
        $('#RecoverPasswordForm').show();
    })
    
    
    
  
});

// // js for popup
// document.addEventListener('DOMContentLoaded', function() {
// // Get the modal
// var modal = document.getElementById('myModalpop');

// // Get the button that opens the modal
// var btn = document.getElementById("myBtnpop");

// // Get the <span> element that closes the modal
// var span = document.getElementsByClassName("closebtn")[0];

// // When the user clicks the button, open the modal 
// btn.onclick = function() {
//   modal.style.display = "block";
// }

// // When the user clicks on <span> (x), close the modal
// span.onclick = function() {
//   modal.style.display = "none";
// }

// // When the user clicks anywhere outside of the modal, close it
// window.onclick = function(event) {
//   if (event.target == modal) {
//     modal.style.display = "none";
//   }
// }
  
// }, false);

